var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video"},[_vm._v(" "+_vm._s(_vm.utils_fileId)+" "),(_vm.newFileId)?_c('video',{staticClass:"tc-video-container",attrs:{"id":_vm.tcPlayerId,"playsinline":"","webkit-playinline":"","x5-playinline":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }